<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter" id="adc"><em>Close to Home</em> Books by John McPherson</h1>
<p class="center01"><em>Close to Home<br/>One Step Closer to Home<br/>Dangerously Close to Home<br/>Home: The Final Frontier<br/>The Honeymoon Is Over<br/>The Silence of the Lamberts<br/>Striking Close to Home<br/>The Close to Home Survival Guide<br/>Close to Home Uncut<br/>The Scourge of</em> <em>Vinyl Car Seats<br/>Close to Home Exposed<br/>Ferociously Close to Home<br/>When Bad Things Happen to Stupid People<br/>A Million Little Pieces of Close to Home<br/>Everything I Need to Know I Learned on Jerry Springer</em><br/><br/></p>
<p class="center01"><strong>Treasury Collections</strong><br/>Close to Home Revisited<br/>Close to Home Unplugged<br/><br/></p>
<p class="center01"><strong>Also from John McPherson</strong><br/>High School Isn’t Pretty<br/>Close to Home: <em>A Book of Postcards<br/>The Barber of Bingo<br/>The Get Well Book<br/>Give Mommy the Superglue and Other Tips on Surviving Parenthood<br/>Get Well, Doctor’s Orders! A Close to Home Get Well Box<br/>Great Sex After 50! And Other Outlandish Lies About Getting Older</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781449406202_epub_adc_r1.vue?6ab775e4